import React from 'react';

import { Header } from 'semantic-ui-react';

import { InviteUsers, ViewAccessWrapper } from '../../components';
import { SETTINGS_TEAM_USERS } from '../../constants/views';

const ManageUsers = () => (
  <>
    <Header
      as="h1"
      content="Manage Team Users"
    />
    <InviteUsers hideTitle showFooter />
  </>
);

const ManageUsersWrapper = () => (
  <ViewAccessWrapper
    viewName={SETTINGS_TEAM_USERS}
    viewComponent={<ManageUsers />}
  />
);

export default ManageUsersWrapper;
